function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4,.cls-7{fill:#333;}.cls-4{font-size:50px;font-family:Montserrat-ExtraBold, Montserrat;font-weight:700;letter-spacing:-0.01em;}.cls-5{letter-spacing:0em;}.cls-6,.cls-7{stroke:#333;stroke-miterlimit:10;stroke-width:4px;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 22,
  y: 26,
  width: 22,
  height: 22
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "PDF Icon");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1-2",
  "data-name": "Ebene 1"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("g", {
  className: "cls-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M32.36,27l2.71,10.58h.06L37.9,28a10.31,10.31,0,0,0-4.85-1.21c-.25,0-.5,0-.75,0a1.27,1.27,0,0,1,.06.18"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M28.64,46.08c0-1.2.9-1.8,2.1-1.78h.46c.59,0,1.24,0,1.6-1.39L28.37,29.47c-.19-.59-.33-1-.42-1.35a10.32,10.32,0,0,0,.72,18.32,2.19,2.19,0,0,1,0-.36"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M41.39,31,36.68,43.61a8.13,8.13,0,0,1-2.28,3.72,10.31,10.31,0,0,0,7-16.31"
}))), /*#__PURE__*/React.createElement("text", {
  className: "cls-4",
  transform: "translate(19.37 165.25)"
}, "P", /*#__PURE__*/React.createElement("tspan", {
  className: "cls-5",
  x: 36.35,
  y: 0
}, "DF")), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M108.62,2H14A12,12,0,0,0,2,14V184a12,12,0,0,0,12,12H136a12,12,0,0,0,12-12V41.38Z"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-7",
  points: "107.02 2 107 42 148 42"
})));

var SvgPdfIcon = function SvgPdfIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 198",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PDFIcon.2392b8fc.svg";
export { ForwardRef as ReactComponent };